import Content from './content';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import { Login as LoginAssets } from '@CS/assets';
import {
  LoginScreen,
  Logo,
  InfoContainer,
  Title,
  Text,
  Box
} from './Login.styles';

type LoginProps = {
  onLogin: () => void;
};

export const Login = ({ onLogin }: LoginProps) => {
  const { title, text, button } = useTranslation(Content);

  return (
    <LoginScreen aria-label="login">
      <Logo alt="Login" src={LoginAssets.Logo} />

      <InfoContainer>
        <Box>
          <Title>{title}</Title>
          <Text>{text}</Text>
          <Button onClick={onLogin} text={button} />
        </Box>
      </InfoContainer>
    </LoginScreen>
  );
};
